// extracted by mini-css-extract-plugin
export default {"box":"Box_box__uzrU4","title":"Box_title__2CuLA font-sm-bold"};